module.exports = __webpack_public_path__ + "img/f0b309e.jpg";